import gql from 'graphql-tag'

export const getStoreConfig = gql`
  {
    storeConfig{
      carriers_freeshipping_free_shipping_subtotal
      carriers_flatrate_price
      payment_payeezy_hide_other_methods
      checkoutrecaptcha_general_sitekey
    }
  }
`
